export const credType = 'Basic'
export const credUsername = 'rest-client'
export const credPassword = '$tL{x<M5u#pK~}56Lx5L41mRd][`{3'
